import * as yup from 'yup';
import dayjs from 'dayjs';
import { LeaseFieldNames } from './HorseLeasingConstants';
import { TranslationKeys } from '../../../../constants/TranslationKeys';

export const getHorseLeasingSchema = (translate) => yup.object().shape({
    [LeaseFieldNames.HORSE_ID]: yup.string().required(translate(TranslationKeys.REQUIRED_FIELD, "Required Field")),
    [LeaseFieldNames.LESSEE_ID]: yup.mixed().test(
        "required",
        translate(TranslationKeys.REQUIRED_FIELD, "Required Field"),
        (value) => value !== null && value !== undefined && value !== ""
    ),
    [LeaseFieldNames.LEASE_START_DATE]: yup.string()
        .required(translate(TranslationKeys.REQUIRED_FIELD, "Required Field"))
        .test("max-today", translate(TranslationKeys.INVALID_DATE, "Date must be today or earlier"), (value) => {
            if (!value) return true;
            return dayjs(value).isBefore(dayjs().add(1, 'day'), 'day');
        }),
    [LeaseFieldNames.LEASE_END_DATE]: yup.string()
        .required(translate(TranslationKeys.REQUIRED_FIELD, "Required Field"))
        .test("min-tomorrow", translate(TranslationKeys.INVALID_DATE, "Date must be tomorrow or later"), (value) => {
            if (!value) return true;
            return dayjs(value).isAfter(dayjs(), 'day');
        }),
    [LeaseFieldNames.CAN_PARTICIPATE_BEAUTY]: yup.boolean().test(
        "at-least-one-permission",
        translate(TranslationKeys.AT_LEAST_ONE_PERMISSION_REQUIRED, "At least one Lessee Permission is required"),
        function (value) {
            const parent = this.parent;
            const c1 = parent[LeaseFieldNames.CAN_COVER_REGISTER];
            const c2 = parent[LeaseFieldNames.CAN_REGISTER_OTHER];
            const c3 = parent[LeaseFieldNames.CAN_IMPORT_EXPORT];
            return value === true || c1 === true || c2 === true || c3 === true;
        }
    ),
    [LeaseFieldNames.COVERING_CERT_NO]: yup.string().when(LeaseFieldNames.IS_MARE_COVERED, {
        is: true,
        then: () => yup.string().required(translate(TranslationKeys.REQUIRED_FIELD, "Required Field")),
        otherwise: () => yup.string().nullable().notRequired()
    }),
    [LeaseFieldNames.STALLION_NAME]: yup.string().when(LeaseFieldNames.IS_MARE_COVERED, {
        is: true,
        then: () => yup.string().required(translate(TranslationKeys.REQUIRED_FIELD, "Required Field")),
        otherwise: () => yup.string().nullable().notRequired()
    }),
    [LeaseFieldNames.COVERING_DATE]: yup.string().when(LeaseFieldNames.IS_MARE_COVERED, {
        is: true,
        then: () => yup.string().required(translate(TranslationKeys.REQUIRED_FIELD, "Required Field")),
        otherwise: () => yup.string().nullable().notRequired()
    })
});
